@if (isLoading || purchases.length > 0) {
  <div class="flyout-row">
    <div class="flyout-data-group">
      <mat-expansion-panel [expanded]="true" class="mat-elevation-z0">
        <mat-expansion-panel-header [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
          <mat-icon class="section-icon">shopping_cart</mat-icon>
          <span>
            {{ "data-platform.purchases" | translate }}
            @if (!isLoading && purchases.length > 0) {
              ({{ purchases.length }})
            }
          </span>
        </mat-expansion-panel-header>

        @if (isLoading) {
          <div class="section-skeleton">
            @for (row of [55, 70, 45]; track $index) {
              <div class="section-skeleton__row">
                <span class="section-skeleton__cell" [style.width.%]="row"></span>
                <span class="section-skeleton__cell section-skeleton__cell--end"></span>
              </div>
            }
          </div>
        } @else {
          @if (hasAnyAmount) {
            @if (showSummaryCards && rows.length > 1) {
              <div class="purchase-kpis">
                <div class="purchase-kpi">
                  <div class="purchase-kpi__value">{{ totalRevenue | formatCurrency: currency }}</div>
                  <div class="purchase-kpi__label">{{ "data-platform.total-revenue" | translate }}</div>
                </div>
                <div class="purchase-kpi">
                  <div class="purchase-kpi__value">{{ avgOrderValue | formatCurrency: currency }}</div>
                  <div class="purchase-kpi__label">{{ "data-platform.avg-order-value" | translate }}</div>
                </div>
                <div class="purchase-kpi">
                  <div class="purchase-kpi__value">{{ rows.length | toLocaleNumber }}</div>
                  <div class="purchase-kpi__label">{{ "data-platform.orders" | translate }}</div>
                </div>
              </div>
            } @else {
              <div class="expansion-panel-row no-border purchase-total-row">
                <div class="label">
                  <span>{{ "data-platform.total-revenue" | translate }}</span>
                </div>
                <div class="value">
                  <strong>{{ totalRevenue | formatCurrency: currency }}</strong>
                </div>
              </div>
            }
          }
          @for (purchase of rows; track purchase.key) {
            <div
              class="expansion-panel-row no-border purchase-row"
              [class.purchase-row--clickable]="interactive"
              [attr.role]="rowRole"
              [attr.tabindex]="rowTabindex"
              [matTooltip]="'data-platform.open-visit' | translate"
              [matTooltipDisabled]="!interactive"
              (click)="onRowClick(purchase)"
              (keydown.enter)="onRowClick(purchase)"
              (keydown.space)="onRowClick(purchase); $event.preventDefault()">
              <div class="purchase-date">{{ purchase.date | formatDate }}</div>
              <div class="purchase-amount">
                @if (purchase.hasAmount) {
                  {{ purchase.amount | formatCurrency: currency }}
                } @else {
                  <span class="purchase-amount--missing">{{ "data-platform.purchase-no-amount" | translate }}</span>
                }
              </div>
              @if (interactive) {
                <mat-icon class="purchase-row-chevron">chevron_right</mat-icon>
              }
            </div>
          }
        }
      </mat-expansion-panel>
    </div>
  </div>
}
